import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class TabletRoutinesService {
  ROUTINE_API_URL = `${environment.tabletUrl}/autoassign-routine-model`;

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  getAutoAssignedRoutines() {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get(this.ROUTINE_API_URL, { headers: httpHeaders });
  }

  createAutoAssignedRoutine(data: any) {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post(
      this.ROUTINE_API_URL,
      {
        userName: data.userName,
        gender: data.gender,
        trainingExperienceMonths: data.trainingExperienceMonths,
        muscleGroupPriority: data.muscleGroupPriority,
        expectedTrainingTime: data.expectedTrainingTime,
        forbiddenExercises: data.forbiddenExercises,
      },
      { headers: httpHeaders }
    );
  }

  finishAutoAssignedRoutine(routineModelId: number) {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post(`${this.ROUTINE_API_URL}/${routineModelId}/finish`, {
      headers: httpHeaders,
    });
  }
}
